// A program day's title. The program builder and the template library write it to
// `program_days.name`; `day_name` is the older column, and most days leave it empty. Reading only
// `day_name` showed "Day 1" for a day called "Upper A - Press & Pull" (13 October 2026).
// A query that shows a day's title must ask for both columns.
export const dayTitle = (day) => (day?.day_name || day?.name || '').trim();
